

import {FlexRow} from '../../Global.style';
import styled from 'styled-components';


export const NavSection= styled(FlexRow)`
    height: 80px;
    width:100%;
    box-sizing: border-box;
    padding: 0 5%;
    background: #000;
    /* background-color:rgb(200 199 204 / 50%) */
`;

export const LogoImg= styled ('img')`
    max-height:75px;
    object-fit: cover;
`